import { JournodexSubjectApiModel } from '../../../api/journodex/model/journodex-subject-api.model';
import { LocalizedStringModel } from '../../../api/journodex/model/localized-string.model';
import { LanguageTagEnum } from '../../../Core/Localization/enums/language-tag.enum';
export class JournodexSubjectParentModel {
    id: number;
    name: string;
    children: JournodexSubjectModel[];
    tooltip?: string;
    locale?: string;

    constructor(apiModel: JournodexSubjectApiModel, locale: string = 'en-US') {
        if (apiModel) {
            this.id = apiModel.id;
            const name = apiModel.names?.find(n => LanguageTagEnum[n.locale] || n.locale === locale);
            this.name = name?.value ?? '';
        } else {
            this.name = '';
        }
        this.children = []; // Api returns an empty children array
        this.locale = locale;
    }

    setChildren(children: JournodexSubjectApiModel[], locale: string) {
        this.children = children?.map(child => new JournodexSubjectModel(child, this, locale)) ?? [];
    }

    toApiModel(): JournodexSubjectApiModel {
        return {
            id: this.id,
            parent: null,
            children: [],
            names: [{ value: this.name, locale: this.locale }]
        };
    }

    clone(): JournodexSubjectParentModel {
        const clone = new JournodexSubjectParentModel(this.toApiModel(), this.locale);
        if (this.children.length) {
            this.children.map(child => clone.children.push(new JournodexSubjectModel(child.toApiModel(), child.parent, this.locale)));
        }
        return clone;
    }
}

export class JournodexSubjectModel {
    id: number;
    parent: JournodexSubjectParentModel;
    name: string;
    names: LocalizedStringModel[];
    tooltip?: string;
    locale?: string;

    constructor(subject: JournodexSubjectApiModel, parent: JournodexSubjectParentModel, locale: string = 'en-US') {
        if (subject) {
            this.id = subject.id;
            this.names = subject.names || [];
            this.name = this.names.find(name => LanguageTagEnum[name.locale] || name.locale === locale)?.value ?? '';
            if (parent) {
                this.parent = parent;
            }
        }
        this.locale = locale;
    }


    /** TODO: Are these needed? */
    // isDirectChildOf(id: number): boolean {
    //     return (id === null && !this.parent) || (this.parent && this.parent.id === id);
    // }
    // isChildOfId(id: number): boolean {
    //     if (!this.parent) {
    //         return false;
    //     }
    //     return this.parent.id === id || this.parent.isChildOfId(id);
    // }
    // isDirectParentOf(id: number): boolean {
    //     return this.children && !!this.children.find(child => child.id === id);
    // }
    // isParentOfId(id: number): boolean {
    //     if (!this.children) {
    //         return false;
    //     }
    //     return !!this.children.find(child => child.id === id || child.isParentOfId(id));
    // }

    toApiModel(): JournodexSubjectApiModel {

        const apiParent = this.parent ? {
            id: this.parent.id,
            names: [{
                value: this.parent.name,
                locale: this.locale
            }],
            children: []
        } : null;


        return {
            id : this.id,
            names: [{
                value: this.name,
                locale: this.locale
            }],
            parent: apiParent
        };
    }
}
